import type { SurfaceBranding } from "@/services/api/agentic-v2/types";

export function normalizeSurfaceBranding(
  branding: SurfaceBranding | null | undefined,
): SurfaceBranding {
  const legacy = branding?.logo_url ?? null;
  const dark = branding?.logo_url_dark ?? legacy;
  const light = branding?.logo_url_light ?? null;
  return {
    logo_url_dark: dark,
    logo_url_light: light,
    logo_url: dark ?? light ?? legacy,
    show_company_name: branding?.show_company_name ?? true,
  };
}

export function resolveHomeBrandLogoUrl(
  branding: SurfaceBranding | null | undefined,
  isDark: boolean,
): string | null {
  if (!branding) return null;
  const normalized = normalizeSurfaceBranding(branding);
  const dark = normalized.logo_url_dark ?? null;
  const light = normalized.logo_url_light ?? null;
  if (isDark) {
    return dark ?? light;
  }
  return light ?? dark;
}

export function readStoredHomeLogoUrls(
  branding: SurfaceBranding | null | undefined,
): { dark: string | null; light: string | null } {
  if (!branding) {
    return { dark: null, light: null };
  }
  return {
    dark: branding.logo_url_dark ?? branding.logo_url ?? null,
    light: branding.logo_url_light ?? null,
  };
}
